export default __webpack_public_path__ + "static/media/logo-salud-filled.bd80c900.svg";